<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="50rem"
    scrollable
  >
    <template v-slot:activator="{ on: dialog }">
      <v-badge
        :value="getUncompletedIntegratedTransactions.length > 0"
        bottom
        left
        overlap
        color="error"
        :content="getUncompletedIntegratedTransactions.length"
      >
        <v-btn
          icon
          v-on="{ ...dialog }"
          :color="getLastReportIsRecent ? 'success' : ''"
        >
          <v-icon>fa-bell</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row align="center" justify="space-between" no-gutters>
          <v-chip
            v-if="getLastIntegratedTransactionReport"
            label
            :color="getLastReportIsRecent ? 'success' : ''"
          >
            <span class="subtitle-1"
              >Dernier raport envoyé le
              {{
                getLastIntegratedTransactionReport.created | localFormat
              }}</span
            >
          </v-chip>
          <v-spacer v-else></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              icon
              text
              small
              :color="hover ? 'error' : ''"
              @click="deleteAllTransactions"
            >
              <v-icon small>fa-trash</v-icon>
              <v-icon
                small
                class="mt-2"
                style="margin-left: -11px; margin-right: -5px;"
                >fa-level-down-alt</v-icon
              >
            </v-btn>
          </v-hover>
        </v-row>
        <InventoryTransactionList v-show="!loading"></InventoryTransactionList>
        <v-row no-gutters v-show="loading">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { api } from "@/api";
import { mapGetters } from "vuex";
import InventoryTransactionList from "./InventoryTransactionList";
export default {
  name: "InventoryTransactionNotification",
  components: {
    InventoryTransactionList
  },
  created() {
    this.$store.dispatch("loadIntegratedTransactions", {
      uncompleted: true,
      deleted: false
    });
    this.$store.dispatch("loadLastIntegratedTransactionReport");
  },
  computed: {
    ...mapGetters([
      "getUncompletedIntegratedTransactions",
      "getLastIntegratedTransactionReport"
    ]),
    getLastReportIsRecent() {
      if (this.getLastIntegratedTransactionReport) {
        return moment(
          this.getLastIntegratedTransactionReport.created
        ).isSameOrAfter(moment().subtract(1, "h"));
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false
    };
  },
  methods: {
    async deleteAllTransactions() {
      const allow = await this.$dialog.confirm({
        text:
          "Voulez-vous vraiment supprimer toutes les transactions dans cette liste?",
        title: ""
      });
      if (allow) {
        try {
          this.loading = true;
          const tasks = [];
          this.getUncompletedIntegratedTransactions.forEach(item => {
            const d = {
              ...item,
              is_deleted: true
            };
            tasks.push(api.updateIntegratedTransaction(item.id, d));
          });
          await Promise.all(tasks);
          await this.$store.dispatch("loadIntegratedTransactions", {
            uncompleted: true,
            deleted: false
          });
        } finally {
          this.loading = false;
        }
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        this.$store.dispatch("loadLastIntegratedTransactionReport");
      }
    }
  }
};
</script>

<style></style>
